import { getInitialState } from './initialState';
import { SET_SEARCH_STATE, SET_TAB, SET_TAB_VALUE } from '../constants';
export const search = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_SEARCH_STATE: {
            return action.payload;
        }
        case SET_TAB: {
            return { ...state, activeTabId: action.payload };
        }
        case SET_TAB_VALUE: {
            return {
                ...state,
                tabs: state.tabs.map((tab) => tab.id !== action.payload.tabId ? tab : { ...tab, value: action.payload.value }),
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map